import React from "react";

const StateShape1 = () => {
	return (
		<svg width={739} height={902} viewBox="0 0 739 902" fill="none">
			<g filter="url(#filter0_f_31_336)">
				<path
					d="M193.943 586.966C282.061 626.157 385.083 586.084 424.051 497.462C463.019 408.839 423.176 305.225 335.057 266.034C246.94 226.843 143.917 266.915 104.949 355.538C65.9807 444.161 105.825 547.775 193.943 586.966Z"
					fill="url(#paint0_radial_31_336)"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_31_336"
					x={-210}
					y={-49}
					width={949}
					height={951}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={150}
						result="effect1_foregroundBlur_31_336"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_31_336"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(603.003 641.288) rotate(-154.311) scale(807.103 735.532)"
				>
					<stop offset="0.34394" stopColor="#00EBFF" />
					<stop offset="0.619147" stopColor="#FF39B0" />
					<stop offset="0.974236" stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default StateShape1;
